// What each role has to approve. Shared by the Aprobare page, the home dashboard and the sidebar badge.
import * as api from "./api";

// Every request follows its own approval circuit (Configurare), so the server works out what waits for whom
export async function fetchApprovalQueue(role) {
  if (role === "admin") return api.getAllApprovalData();
  if (!hasApprovalQueue(role)) return [];
  return api.getMyQueue();
}

/**
 * What waits for the caller themselves: their decisions, or their work as a type's engineer. For the admins that
 * is the work of the types Configurare gives them: the badge, the home tile, „De executat” in Aprobare.
 */
export async function fetchMyWork(role) {
  if (!hasWorkQueue(role)) return [];
  return api.getMyQueue();
}

// One row per request
export function uniqueByRequest(rows) {
  const seen = new Set();
  return rows.filter((x) => !seen.has(x.requestId) && seen.add(x.requestId));
}

// Admin's list is every request ever made, so a "waiting" count means nothing there
export function hasApprovalQueue(role) {
  return ["usersef", "rector", "contability", "inginer-pc", "inginer", "dtisef"].includes(role);
}

// Roles with a count of their own work: the approvers and engineers, plus the admins for the demersuri they execute
export function hasWorkQueue(role) {
  return hasApprovalQueue(role) || role === "admin";
}
